import { useTranslation } from 'react-i18next';
import { $userStore } from '@lib/store';
import { useRouteHook } from '@shared/hooks';
import { RoutePaths } from '@shared/utils';
import { Button, Modal, Text } from '@shared/widgets';

interface IDeleteUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  userId: string;
}

export const DeleteUserModal = (props: IDeleteUserModalProps) => {
  const { navigate } = useRouteHook();

  const { t } = useTranslation('user');

  const deleteUserHandler = async () => {
    const statusCode = (await $userStore.events.deleteUser(props.userId)) as unknown as number;
    if (statusCode === 204) navigate(RoutePaths.users.onNavigate({ successDeleted: true }));
  };

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} title={t('sidebar.modals.deleteUser.title')}>
      <Text className='text-center'>{t('sidebar.modals.deleteUser.description')}</Text>
      <div className='mt-6 flex gap-2'>
        <Button color='outlined' fullWidth onClick={props.onClose}>
          {t('buttons.close', { ns: 'common' })}
        </Button>
        <Button color='primary' fullWidth onClick={deleteUserHandler}>
          {t('buttons.delete', { ns: 'common' })}
        </Button>
      </div>
    </Modal>
  );
};
